import React, { useEffect, useState } from 'react';
import { buscarProveedores } from '../../services/data';
import { useAutocompletar, BotonLimpiar } from './useAutocompletar';

// Autocompletar proveedores. Las compras admiten texto libre; pagos a facturas requieren proveedor catalogado.
export default function ProveedorAutocomplete({ value, onChange, soloCatalogo = false, disabled, id }) {
  const [texto, setTexto] = useState(value?.nombre || '');
  const [opciones, setOpciones] = useState([]);
  const { abierto, setAbierto, ref, listId, propsInput, limpiar, botonCerrar } = useAutocompletar();

  useEffect(() => { setTexto(value?.nombre || ''); }, [value?.id, value?.nombre]);
  useEffect(() => {
    if (!abierto) return undefined;
    const t = setTimeout(() => { buscarProveedores(texto).then(setOpciones).catch(() => setOpciones([])); }, 200);
    return () => clearTimeout(t);
  }, [texto, abierto]);

  const escribir = (e) => {
    setTexto(e.target.value);
    setAbierto(true);
    onChange({ id: null, nombre: e.target.value, diasCredito: null }); // al escribir se pierde la selección
  };
  const elegir = (p) => { setTexto(p.nombre); setAbierto(false); onChange({ id: p.id, nombre: p.nombre, diasCredito: p.diasCredito }); };
  const exacto = opciones.find((p) => p.nombre.trim().toLowerCase() === texto.trim().toLowerCase());

  return (
    <div className="ct-auto" ref={ref}>
      <span className="auto-campo">
        <input id={id} {...propsInput} value={texto} onChange={escribir} onBlur={() => { if (!value?.id && exacto) elegir(exacto); else setAbierto(false); }} disabled={disabled}
          placeholder="Escribe para buscar…" className={!disabled && texto ? 'auto-con-limpiar' : undefined} />
        {value?.id && <span className="ct-auto-ok" title="Proveedor del catálogo">✓</span>}
        <BotonLimpiar visible={!disabled && !!texto} etiqueta="Limpiar proveedor"
          onClick={() => limpiar(() => { setTexto(''); onChange({ id: null, nombre: '', diasCredito: null }); })} />
      </span>
      {!disabled && texto.trim() && !value?.id && !abierto && !soloCatalogo && <small className="prod-auto-nuevo">Pendiente de revisar</small>}
      {abierto && !disabled && (
        <ul className="ct-auto-list" role="listbox" id={listId}>
          {botonCerrar}
          {opciones.map((p) => (
            <li key={p.id} role="option" aria-selected={value?.id === p.id}>
              <button type="button" onPointerDown={(e) => { e.preventDefault(); elegir(p); }} onClick={() => elegir(p)}>
                <b>{p.nombre}</b>{p.nombreComercial && <span> · {p.nombreComercial}</span>}<small>{p.diasCredito} días de crédito</small>
              </button>
            </li>
          ))}
          {!opciones.length && <li className="ct-auto-vacio">{soloCatalogo ? 'Sin coincidencias en el catálogo. Selecciona un proveedor con facturas pendientes.' : 'Sin coincidencias: se registrará con el nombre escrito.'}</li>}
        </ul>
      )}
    </div>
  );
}
